import 'theme/index.global.less';

import reducer from 'store/ducks';
import renderApp from './renderApp';

console.log('version:', __GIT_VERSION__);

renderApp(reducer, window.__data);
